import { render, staticRenderFns } from "./Appliances.vue?vue&type=template&id=5d0a1ce0"
import script from "./Appliances.vue?vue&type=script&lang=js"
export * from "./Appliances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports